/**
 * Defines the treatment of non-cash dividends.
 * tag: 42258
 * @readonly
 * @enum {number} (int)
 */
export enum NonCashDividendTreatment {
  PotentialAdjustment = 0,
  CashEquivalent = 1,
}
